import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const Analyser = lazy(() => import("@/pages/mina-sidor/Analyser"));

export const Route = createFileRoute("/mina-sidor/analyser")({
  component: () => <Analyser />,
});
